import { DatePipe } from '@angular/common';
import { Component,ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {PAGELENGTH } from 'src/app/endpoints';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
@Component({
  selector: 'app-sample-allocated-to-dis',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    NgSelectModule,
    MatTabsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    DatePipe,
    MatLabel,
    MatInputModule,
    RouterLink
  ],
  templateUrl: './sample-allocated-to-dis.component.html',
  styleUrl: './sample-allocated-to-dis.component.scss'
})
export class SampleAllocatedToDisComponent {



startpoint: number = 0;
totalLoaded: number = 0;
total: number = 0;
pageNo: number = 0;
  pageSize: number = 10;
companyId: any;
companyRes: any;
companyDetail: any;
companySearch: any;

distributorId: any;
distributorType: any;
singleDistributor: any;

issuerDistributorId: any;
sid: any;

allCategoriesMini: any;
receiverType: number = 1;

debounceNameTimer: any = null;
debounceBarCodeTimer: any = null;

sampleSearch: any = {
  name: '',
  category: undefined,
  startdate: null,
  enddate: null,
  barCode: ''
};

// Table Configs
samplesDataSource = new MatTableDataSource<any>([]);
sampleDisplayedColumns: string[] = [
  'srno', 'name', 'sampleCode', 'totalItems', 'leftItems',
  'issuedWHL', 'issuedRTL', 'issuedCus', 'issuedTotal', 'limit', 'hold',
  'createdAt', 'action'
];

headerRowDef1: string[] = [
  'srno', 'name', 'sampleCode', 'totalItems', 'leftItems',
  'issuedGroup', 'limit', 'hold', 'createdAt', 'action'
];

headerRowDef2: string[] = [
  'issuedWHL', 'issuedRTL', 'issuedCus', 'issuedTotal'
];

issuedSamplesToDistributorsDataSource = new MatTableDataSource<any>([]);
issuedSamplesToDistributorsDisplayedColumns: string[] = [
  'srno', 'name', 'email', 'phone', 'quantityAssigned', 'quantityRemaining', 'distributorLimit'
];
issuedSamplesToCustomersDisplayedColumns: string[] = [
  'srno', 'name', 'email', 'phone', 'issuedQuantity'
];

@ViewChild(MatPaginator) paginator: MatPaginator;


constructor(
  private userService: UserServiceService,
  private companyService: CompanyService,
  private categoryService: CategoryService,
  private sampleService: SampleService,
  private toastr: ToastrService,
  private spinner: NgxSpinnerService,
  private activatedRoute: ActivatedRoute
) {}


ngOnInit(): void {
  this.companyId = this.activatedRoute.snapshot.paramMap.get("companyId");
  this.distributorId = this.activatedRoute.snapshot.paramMap.get("distributorId");
  this.distributorType = this.activatedRoute.snapshot.paramMap.get("distributorType");

  this.getSingleCompany();
  this.getAllCategoriesMini();
  this.getAllSamples(null);
  this.getSingleDistributor();
}




getSingleCompany(): void {
  if (!this.companyId) return;
  this.spinner.show();
  this.companyService.singleCompany({ _id: this.companyId }).subscribe({
    next: (res: any) => {
      if (res.success) this.companyDetail = res.data;
    },
    error: (e) => this.toastr.error(e.message, 'Error'),
    complete: () => this.spinner.hide()
  });
}

getSingleDistributor(): void {
  if (!this.distributorId) return;
  this.spinner.show();
  this.userService.singleDistributor({ _id: this.distributorId }).subscribe({
    next: (res: any) => {
      if (res.success) this.singleDistributor = res.data;
    },
    error: (e) => this.toastr.error(e.message, 'Error'),
    complete: () => this.spinner.hide()
  });
}

getAllCategoriesMini(): void {
  this.categoryService.allCategoriesMini({}).subscribe({
    next: (res) => {
      if (res.success) this.allCategoriesMini = res.data;
    },
    error: (e) => this.toastr.error(e)
  });
}


calculateAge(dob: string | Date): number {
  if (!dob) return 0;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
  return age;
}


onNameInputChange(event: any): void {
  clearTimeout(this.debounceNameTimer);
  this.debounceNameTimer = setTimeout(() => {
    const name = event.target.value.trim();
    this.sampleSearch.name = name || undefined;
    this.getAllSamples(null);
  }, 300);
}

onBarCodeInputChange(event: any): void {
  clearTimeout(this.debounceBarCodeTimer);
  this.debounceBarCodeTimer = setTimeout(() => {
    const code = event.target.value.trim();
    this.sampleSearch.barCode = code || undefined;
    this.getAllSamples(null);
  }, 300);
}

clearDateRange(): void {
  this.sampleSearch.startdate = null;
  this.sampleSearch.enddate = null;
  this.getAllSamples(null);
}

sampleFilter(event: any): void {
  this.getAllSamples(null);
}


getAllSamples(event: any): void {
  if (!this.companyId) {
    this.toastr.error("Company Id required");
    return;
  }

  // Reset on first load or filter clear
  if (!event) {
    this.pageNo = 0;
    this.startpoint = 0;
    this.pageSize = this.pageSize || PAGELENGTH;
    this.samplesDataSource.data = [];
    this.totalLoaded = 0;
  }

  // Handle page size change
  if (event?.pageSize && event.pageSize !== this.pageSize) {
    this.pageSize = event.pageSize;
    this.pageNo = 0;
    this.startpoint = 0;
    this.samplesDataSource.data = [];
    this.totalLoaded = 0;
  }

  // Handle page index change
  if (event?.pageIndex !== undefined) {
    this.pageNo = event.pageIndex;
    this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
  }

  const data: any = {
    startpoint: this.startpoint,
    limit: this.pageSize || PAGELENGTH,
    companyId: this.companyId,
    receiverDistributorId: this.distributorId,
    companySearch: this.companySearch
  };

  if (this.sampleSearch.name) data.name = this.sampleSearch.name;
  if (this.sampleSearch.barCode) data.sampleCode = this.sampleSearch.barCode;
  if (this.sampleSearch.category) data.categoryId = this.sampleSearch.category;
  if (this.sampleSearch.startdate) data.startdate = this.sampleSearch.startdate;
  if (this.sampleSearch.enddate) data.enddate = this.sampleSearch.enddate;

  this.spinner.show();
  this.sampleService.allIssuedSamplesDistributor(data).subscribe({
    next: (res) => {
      if (res.success) {
        this.total = res.total ?? 0;
        this.samplesDataSource.data = res.data || [];
        this.totalLoaded = this.samplesDataSource.data.length;

        setTimeout(() => {
          if (this.paginator) {
            this.paginator.pageIndex = this.pageNo;
            this.paginator.length = this.total;
            this.paginator.pageSize = this.pageSize ?? PAGELENGTH;
          }
        }, 0);
      }
    },
    error: (e) => {
      this.toastr.error(e.message || 'Failed to load samples');
    },
    complete: () => this.spinner.hide()
  });
}













}
